import React, { useEffect } from 'react';
import clsx from 'clsx';
import { Checkbox } from '@material-ui/core';
import DropdownMechanism from '../../../../../GeneralComponents/DropdownMechanism';

const DefineAlgorithmResource = (props) => {
  const {
    editor,
    clickedEdit,
    entities
  } = props;

  // const handleDefineServiceParam = () => {
  //   setIsAlgorithmResource(!isAlgorithmResource);
  //   console.log('this is the resource', algorithmResource);
  // };

  const openEditor = () => {
    const commands = editor.Commands;
    document.getElementById('editDataElementPopUp').style.visibility = 'hidden';
    commands.run('handleInsertCodePanel');
  };

  const [entitiesNames, setEntitiesNames] = React.useState([]);

  useEffect(() => {

  }, [clickedEdit]);


  const selectEntity = (option) => {
    if (option === 'none') return;
    setEntitiesNames([...(new Set([...entitiesNames])).add(option)])
  };

  return (

    <div className={clsx('spacingTopDiv2', 'teamSelector')}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>

        <div style={{ display: 'flex', justifyContent: "space-between" }}>
          <p>Use Entities: </p>
          <ul>{[...entitiesNames].map(entityName => <li key={entityName}>{entityName}</li>)}
          </ul>
          <DropdownMechanism
            target={undefined}
            targets={entities || ['none']}
            selectTarget={selectEntity}
          />
        </div>


        <span aria-hidden="true" onClick={() => openEditor()} className={clsx('openEditorStyle')}>
          {' '}
          Open editor
        </span>
      </div>


    </div >

  );
};

{/* <DropdownMechanism
  target={undefined}
  targets={entitiesNames}
  selectTarget={selectEntity}
/> */}


export default DefineAlgorithmResource;
